import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const intLiveReloadAccount: OepaUserAccount = {
    loginName: 'sd',
    accountID: 'sd',
    firstName: '401',
    lastName: 'Admin',
    primaryEMailAddress: 'samuel.davis@epa.ohio.gov',
    type: 'E_BUSINESS_CENTER',
    roleList: [
      {
        name: 'DSWSWIMSAdmin',
        description: 'SWIMS Admin',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      }
    ]
  }